// /src/hooks/useSwitchLocale.js
"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { withLocaleHref } from "@kkeut/lib/locale-url";

export default function useSwitchLocale() {
  const router = useRouter?.();
  const pathname = usePathname?.() || (typeof window !== "undefined" ? window.location.pathname : "/");
  const searchParams = useSearchParams?.();

  // 언어 접두어를 갈아 끼운다 — 공용 규칙(locale-url). 한국어 /main/X 화면(예: /main/myTickets)에서
  // 외국어로 바꾸면 /en/main/X(404)가 아니라 /en/X 로 간다.
  const buildPath = (nextLocale) => {
    const qs = searchParams && searchParams.size ? `?${searchParams.toString()}` : "";
    return `${withLocaleHref(pathname || "/", nextLocale)}${qs}`;
  };

  const switchLocale = (nextLocale) => {
    const url = buildPath(nextLocale);
    // 쿠키 동기화 (CSR에서도 즉시 반영)
    if (typeof document !== "undefined") {
      document.cookie = `locale=${nextLocale};path=/;max-age=${60 * 60 * 24 * 365}`;
    }
    if (router?.push) router.push(url);
    else if (typeof window !== "undefined") window.location.assign(url);
  };

  return { switchLocale, buildPath };
}
